export default {
  data: () => ({

    chartData:   [],
    cutoff:      null,
    
    canvasForms: null,
    canvasChart: null,

    title:    null,
    timeline: {},
    primary:  null,
    chart:    null,
    sundries: null,
    keys:     null,
    filters:  null,
  }),





  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}